const options = {
  5: "bg-pink-600/5",
  10: "bg-pink-600/10",
  25: "bg-pink-600/25",
  50: "bg-pink-600/50",
  75: "bg-pink-600/75",
  90: "bg-pink-600/90",
  100: "bg-pink-600",
};

const from = {
  5: "from-pink-600/5",
  10: "from-pink-600/10",
  25: "from-pink-600/25",
  50: "from-pink-600/50",
  75: "from-pink-600/75",
  90: "from-pink-600/90",
  100: "from-pink-600",
};

export default function getBackgroundPink600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
